import { render, staticRenderFns } from "./UserDetailMedia.vue?vue&type=template&id=51c0fb7a&scoped=true"
import script from "./UserDetailMedia.vue?vue&type=script&lang=js"
export * from "./UserDetailMedia.vue?vue&type=script&lang=js"
import style0 from "./UserDetailMedia.vue?vue&type=style&index=0&id=51c0fb7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c0fb7a",
  null
  
)

export default component.exports